import React from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet } from 'react-native';
import {
  Button,
  Container,
  IllusEmployeeFork,
  Image,
  theme,
  TitleText,
} from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

// ────────────────────────────────────────────────────────────────────────────────

export const ChallengesScreenContentSignedOut = (
  props: ChallengesScreenContentSignedOutProps,
) => {
  const { testID, onPressSignIn } = props;

  const { t } = useLocalizationContext();

  return (
    <Container
      testID={testID}
      style={styles.containerContent}
      wrapperStyle={styles.containerWrapper}
    >
      <Image
        source={IllusEmployeeFork}
        accessibilityIgnoresInvertColors
        resizeMode="contain"
        style={styles.imageSignedOut}
      />

      <TitleText
        size={5}
        style={styles.text}
        testID="challenges.signed-out.text"
      >
        {t('challenges.sign-out.text')}
      </TitleText>

      <Button
        palette="primary"
        style={styles.cta}
        onPress={onPressSignIn}
        testID="challenges.signed-out.sign-in-btn"
      >
        {t('challenges.sign-out.sign-in-or-join')}
      </Button>
    </Container>
  );
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerWrapper: {
    flexGrow: 1,
    minHeight: '100%',
  },
  containerContent: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: theme.spacing.large,
    backgroundColor: theme.colors.OATMEAL,
  },
  imageSignedOut: {
    width: 242,
    height: 242,
  },
  text: {
    maxWidth: 480,
    textAlign: 'center',
    paddingVertical: theme.spacing.large,
  },
  cta: {
    minWidth: 160,
  },
});

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type ChallengesScreenContentSignedOutProps = {
  readonly onPressSignIn: () => void;
} & Pick<ViewProps, 'testID'>;
